import { CloseIcon, Dropdown, MenuIcon } from "@moznsystems/mozn-ui";
import { logoMini } from "@rageeb/frontend-lib";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const FOCAL_ROUTE_STAGING = "https://staging.sa.focal.mozn.sa";
const FOCAL_ROUTE_PROD = "https://app.sa.focal.mozn.sa";

const AppSwitcher = () => {
	const [isDropdownVisible, setDropdownVisible] = useState(false);
	const { t } = useTranslation("layout");

	const handleDropdown = () => {
		setDropdownVisible(!isDropdownVisible);
	};

	return (
		<Dropdown
			isOpen={isDropdownVisible}
			onOpen={() => setDropdownVisible(true)}
			onClose={() => setDropdownVisible(false)}
			target={
				<button className="open-dropdown-button">
					<MenuIcon className="side-bar__logo_container--drop-icon" />
				</button>
			}
			usePortal
			zIndex={10000}
		>
			<div className="side-bar__logo_container__dropdown">
				<p className="side-bar__logo_container__dropdown__head">
					<span>{t("app_switcher.switch_to")}</span>
					<CloseIcon onClick={handleDropdown} fill="#C0C0CB" />
				</p>
				<a className="side-bar__logo_container__dropdown__link side-bar__logo_container__dropdown__link--active">
					<img src={logoMini} alt={t("logo.alt_focal")} />
					<p>{t("app_switcher.focal_fraud")}</p>
				</a>
				<p className="separator" />
				<a
					href={
						window.location.hostname.includes("staging") ||
						window.location.hostname.includes("preprod")
							? FOCAL_ROUTE_STAGING
							: FOCAL_ROUTE_PROD
					}
					className="side-bar__logo_container__dropdown__link"
					target="_blank"
					rel="noreferrer"
				>
					<img src={logoMini} alt={t("logo.alt_focal")} />
					<p>{t("app_switcher.focal_platform")}</p>
				</a>
			</div>
		</Dropdown>
	);
};

export default AppSwitcher;
